import React, { useState, useEffect } from 'react';

import { useRecoilState } from 'recoil';
import { tokenAtom } from 'core/config/atoms';

import Skeleton from 'react-loading-skeleton';
import moment from 'moment';
import { toast } from 'react-toastify';

import ServiceDonation from 'services/serviceDonation';

export default function ComponentNewQueryList() {

    const [token] = useRecoilState(tokenAtom);

    const [donations, setDonations] = useState([]);

    const [loading, setLoading] = useState(true);

    const donationService = new ServiceDonation();

    const loadData = () => {
        setLoading(true);
        (async function () {
            let body = {
                "filter": {},
                "page": 1,
                "size": 10,
                "searchQuery": '',
                "startDate": "",
                "endDate": ""
            };
            var res = await donationService.getAllDonation(body, token);
            if (res['status']) {
                setDonations(res.data.data);
                setLoading(false);
            } else {
                toast.error('Server error please try again', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
            }
        })();
    }

    useEffect(() => {
        loadData();
    }, []);

    return (
        <div className="col-span-12 cursor-pointer">
            <div className="shadow bg-white rounded-lg p-4">
                <h3 className='text-lg font-sans font-medium'>New Donation Queries | Top 10</h3>
                <hr className='my-2' />
                {loading && <Skeleton count={10} />}
                <table className="min-w-full divide-y divide-gray-200 px-4">
                    <thead className="bg-gray-50">
                        <tr>
                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                                Name
                            </th>
                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                                Email
                            </th>
                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                                Phone
                            </th>
                            <th scope="col" className="px-6 py-3 w-[60px] text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                                Address
                            </th>
                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                                Message
                            </th>
                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                                Amount
                            </th>
                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                                Created At
                            </th>
                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                                Status
                            </th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {
                            donations.length !== 0 && donations.map((contact, index) => {
                                return <tr className="hover:bg-gray-100" key={index}>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <span className="inline-flex text-sm leading-5 font-semibold text-gray-900">
                                            {`${contact.fname} ${contact.lname}`}
                                        </span>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <span className="inline-flex text-sm leading-5 font-semibold text-gray-900">
                                            {contact.email}
                                        </span>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <span className="inline-flex text-sm leading-5 font-semibold text-gray-900">
                                            +91 {contact.phone}
                                        </span>
                                    </td>
                                    <td className="px-6 py-4 w-[320px]">
                                        <span className="inline-flex text-sm leading-5 font-semibold text-gray-900">
                                            {`${contact.address}, ${contact.city}, ${contact.pincode}`}
                                        </span>
                                    </td>
                                    <td className="px-6 py-4 w-[320px]">
                                        <span className="inline-flex text-sm leading-5 font-semibold text-gray-900">
                                            {contact.message}
                                        </span>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <span className="inline-flex text-sm leading-5 font-semibold text-green-600 uppercase">
                                            ₹ {contact.amount}
                                        </span>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <div className="text-sm text-blue-600">
                                            {moment(contact.createdAt).format('DD MMM, yyyy')}
                                        </div>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full uppercase ${contact.status === 'closed' ? 'bg-green-100 text-green-800' : contact.status === 'active' ? 'bg-yellow-100 text-yellow-800' : 'bg-red-100 text-red-800'}`}>
                                            {contact.status.toUpperCase()}
                                        </span>
                                    </td>
                                </tr>
                            })
                        }
                        {
                            donations.length === 0 && <tr className="cursor-pointer hover:bg-gray-100">
                                <td className="px-6 py-4 whitespace-nowrap" colSpan="8">
                                    <div className="text-sm text-blue-600 text-center">
                                        No data found.
                                    </div>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>
    )
}
